define('responsive-gameday/controllers/PlayByPlayViewController',['require','exports','module','GameDayCore','Responsive/controllers/ViewController','Responsive/controllers/ScrollViewController','./LinescoreViewController','./InningPlaysViewController','./ScoringPlaysViewController','../views/render/PlayByPlayViewRender','message-service/message-service','Responsive/util/renderComplete','../views/Monitor/Events/ViewModelUpdateEvents','responsive-gameday-tracking/responsive-gameday-tracking','gameday-resource-path/gameday-resource-path','GameDayCore/GDUtil/resources/GDConfig','GameDayCore/GDUtil/window/Logg','extant/extant'],function(require,exports,module) {
    //(function (win, doc, undef, Re, GameDayUI, $GDC, $GDM) {

    var GDC = require("GameDayCore"),
        ViewController = require("Responsive/controllers/ViewController"),
        ScrollViewController = require("Responsive/controllers/ScrollViewController"),
        LinescoreViewController = require( './LinescoreViewController' ),
        InningPlaysViewController = require( "./InningPlaysViewController" ),
        ScoringPlaysViewController = require( "./ScoringPlaysViewController" ),
        PlayByPlayViewRender = require( '../views/render/PlayByPlayViewRender' ),
        MessageService = require("message-service/message-service"),
        renderComplete = require("Responsive/util/renderComplete"),
        VMEvents = require("../views/Monitor/Events/ViewModelUpdateEvents"),
        Tracking = require("responsive-gameday-tracking/responsive-gameday-tracking"),
        resourcePath = require("gameday-resource-path/gameday-resource-path"),
        GDConfig = require("GameDayCore/GDUtil/resources/GDConfig"),
        Logg = require("GameDayCore/GDUtil/window/Logg"),
        exists = require("extant/extant");
        
        

    // Add private variables here
    var Superclass,
        ACTIVE_CLASS = 'active',
        teams,
        dataMap = {
            play: 'game',
            scores: 'scores',
            game: 'game',
            all_innings: 'game'
        },

    // Add private methods here
        team_code = function (that) {
            return function () {
                return 't' + that.requiredData.game[this.home_or_away].id;
            }
        },

        pitcher_name = function (that) {
            // TODO: see why this is causing a problem (buried the problem with a empty string return);
            return function () {
                Logg.log("THERE WAS A PITCHER, ONCE: " + exists(this.pitcher));
                var pitcher = that.requiredData.players && that.requiredData.players.playerMap[this.pitcher];
                return (exists(pitcher)) ? pitcher.first + ' ' + pitcher.last : "";
            }
        },

        player_thumb = function (that) {
            return function () {
                var batter = that.requiredData.players && that.requiredData.players.playerMap[this.batter || this.player];
                if (batter) {
                    return resourcePath.get('mugshot', {pid: batter.id});
                }
            }
        };

    // Constructor
    function PlayByPlayViewController(mode) {
        var that = this;
        // Call super constructor
        Superclass.constructor.call(this);
        this.canScroll=false;
        this.viewRender = new PlayByPlayViewRender();
        this.content = null;
        this.mode = mode || 'all'; // all or single
        this.active = 0;
        this.activeInning = null;
        this.currentInning = 1;
        this.viewRender.viewState.version = GDConfig.build;
        this.showLinescore = true;
        this.viewRender.viewState = {
            version: GDConfig.build,
            active: that.active,
            tabs: [
                { index: 0 },
                { index: 1 }
            ],
            activeTab: function () {
                return this.index == that.active ? ACTIVE_CLASS : '';
            }
        };

    }

    // Prototype Inheritence
    ViewController.spawn(PlayByPlayViewController).define({
        loadView: function () {
            var that = this;
            Superclass.loadView.call(this);
            this.setClassName("PlayByPlayViewController");

            $(this.getView()).on('click', 'nav.secondary li[data-view]', function (e) {
                var tab = $(this),
                    tabs = tab.siblings(),
                    track = this.getAttribute('data-tracking-call');
                tabs.removeClass('active');
                tab.addClass('active');

                if (track) {
                    Tracking[track]();
                }

                e.preventDefault();
                that.content.setAttribute('data-view', that.active = this.getAttribute('data-view'));
                if(that.dataViews[that.active]){
                    that.dataViews[that.active].setScroll();
                }
                return false;
            });
            this.scores=new ScoringPlaysViewController();
            this.innings=new InningPlaysViewController();
            this.dataViews = [this.scores,this.innings];
            this.childViewControllers.push(this.scores);
            this.childViewControllers.push(this.innings);
            this.scores.parentViewController = this;
            this.innings.parentViewController = this;

        },

        viewWillAppear: function () {
            var that = this;

            that.viewRender.viewState.active = that.active;

            this.onBeat = this.onBeat || function (payload) {
                that.displayPlayByPlay(payload);
            };

            Tracking.track_plays_tab_launch();

            Superclass.viewWillAppear.call(this);
            this.showOverlay();
        },

        viewDidAppear : function(){
            var that=this;
            // console.warn("pbp",this.availableHeight,this.view);
            Superclass.viewDidAppear.call(this);
            MessageService.addListener.call(this,VMEvents.UPDATE_PLAYBYPLAY, this.onBeat);
            MessageService.publish(VMEvents.REQUEST_PLAYBYPLAY_DATA);
        },

        displayPlayByPlay: function (payload) {
            var that = this;

            LinescoreViewController.embeddedHelper(that, payload.linescore);
            if(that.linescoreHolder && that.showLinescore){
                this.linescoreHolder.innerHTML = this.viewRender.renderPartial('embeddedLinescoreView',payload);
                renderComplete(function () {
                    if (!that.isViewLoaded()) {
                        return;
                    }
                    LinescoreViewController.setEmbeddableScrollBar(that, payload.linescore);
                    that.hideOverlay();
                });
            } else {
                this.viewRender.viewState.showLinescore = this.showLinescore;
                this.view.innerHTML = this.viewRender.render(payload);
                renderComplete(function () {
                    if (!that.isViewLoaded()) {
                        return;
                    }
                    that.hideOverlay();
                    LinescoreViewController.setEmbeddableScrollBar(that, payload.linescore);

                    that.content = that.view.querySelector('#plays');
                    that.scoreHolder = that.view.querySelector('.scoringPlays-container');
                    that.inningHolder = that.view.querySelector('.inningPlays-container');
                    that.linescoreHolder = that.view.querySelector('.embedded_linescore_holder');

                    that.scores.viewWillAppear();
                    that.scoreHolder.appendChild(that.scores.getView());
                    that.scores.viewDidAppear();

                    that.innings.viewWillAppear();
                    that.inningHolder.appendChild(that.innings.getView());
                    that.innings.viewDidAppear();
                });
            }
            if(!this.showLinescore){
                return false;
            }
            LinescoreViewController.setEmbeddableScrollBar(that);
        },

        viewWillDisappear: function () {
            if (this.onBeat) {
                MessageService.removeListener.call(this,VMEvents.UPDATE_PLAYBYPLAY, this.onBeat);
            }
            this.linescoreHolder=null;
            Superclass.viewWillDisappear.call(this);
        }
    });

    Superclass = PlayByPlayViewController.superclass;
    return PlayByPlayViewController;
});
